import {
  IllustrationIdApi,
  isGettedIllustrationIdDTO,
} from "../DTO/ServerResponseType/Illustration/IllustrationId";
import {
  IllustrationApi,
  isGettedIllustrationDTO,
} from "../DTO/ServerResponseType/Illustration/Illustration";
import {
  isGettedIllustrationIdsWithOptionalTaskIllustrationIdDTO,
  TaskIllustrationIdsDTOType,
} from "../DTO/ServerResponseType/Task/TaskIllustration";
import { ServerClient, serverOrigin } from "./Configs";
import {
  getTypeGuardedArrayVariableAsync,
  getTypeGuardedVariableAsync,
} from "./typeGuard";

class IllustrationServerClient {
  private path = "/illustration";

  sendToGetAllIllustrationsAsync = async (): Promise<
    IllustrationApi[] | never
  > => {
    let url: string = serverOrigin + this.path + "/show/all";

    let illustrations = getTypeGuardedArrayVariableAsync(
      ServerClient.sendRequestAsync({
        url: url,
        method: "GET",
        credentials: "include",
      }),
      isGettedIllustrationDTO
    ).catch((error) => {
      console.log(error);
      throw error;
    });

    return illustrations;
  };

  sendToDeleteIllustrationAsync = async (
    illustrationId: string
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/delete";

    let sendPromise = ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ illustrationId: illustrationId }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return sendPromise.catch((error) => {
      console.error("Ошибка:", error);
    });
  };

  sendToCreateIllustrationAsync = async (
    illustration: IllustrationApi
  ): Promise<IllustrationIdApi | null> => {
    let illustrationId: IllustrationIdApi | null =
      await getTypeGuardedVariableAsync(
        this.sendNewIllustrationAsync(illustration),
        isGettedIllustrationIdDTO
      )
        .then((illustrationIdDTO: IllustrationIdApi) => {
          alert("Иллюстрация успешно создана.");
          return illustrationIdDTO;
        })
        .catch((error) => {
          console.error("Ошибка:", error);
          return null;
        });

    return illustrationId;
  };

  sendToCreateIllustrationWithConnectionToTaskAsync = async (
    illustration: IllustrationApi,
    taskId: string
  ): Promise<TaskIllustrationIdsDTOType | never> => {
    let illustrationIds = await getTypeGuardedVariableAsync(
      this.sendNewIllustrationAsync(illustration, taskId),
      isGettedIllustrationIdsWithOptionalTaskIllustrationIdDTO
    )
      .then((illustrationIds: TaskIllustrationIdsDTOType) => {
        alert("Иллюстрация успешно создана.");
        return illustrationIds;
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        throw new Error("An error occurred while creating the illustration");
      });

    return illustrationIds;
  };

  sendNewIllustrationAsync = async (
    illustration: IllustrationApi,
    taskId?: string
  ): Promise<unknown | never> => {
    let url: string = serverOrigin + this.path + "/create";

    const formData = new FormData();
    formData.append("illustration", illustration.illustration);
    formData.append(
      "illustrationData",
      JSON.stringify({
        name: illustration.illustrationName,
        author: illustration.illustrationAuthor,
        taskId: taskId,
        type: illustration.illustrationType,
      })
    );

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: formData,
      credentials: "include",
    });

    return response;
  };
}

let illustrationServerClient = new IllustrationServerClient();

export default illustrationServerClient;
